import { DocumentNode } from "graphql";
import { AsyncEntityThunkConfig } from "./asyncEntityStateUtil";
import { EntityId, GetThunkAPI } from "@reduxjs/toolkit";
import { ApolloQueryResult } from "@apollo/client";

export function fetchByIdFactory<ResponseObject, T>(query: DocumentNode, responseSelector: (queryResponse: ApolloQueryResult<ResponseObject>) => T[]) {
  return async (ids: number[], thunkApi: GetThunkAPI<AsyncEntityThunkConfig<T[]>>) => {
    const {getApolloClient} = thunkApi.extra;
    const state = thunkApi.getState();
    const domain = state.activeData.farm;
  
    if (!domain) {
      thunkApi.rejectWithValue([]);
    }
  
    try {
      const client = getApolloClient();
      const queryResponse = await client.query<ResponseObject>({query, variables: {domain, input: {ids}}})
      return thunkApi.fulfillWithValue(responseSelector(queryResponse));
    } catch (error) {
      return thunkApi.rejectWithValue([]);
    }
  }
} 

export function fetchByIdWithoutInputFactory<ResponseObject, T, Id extends EntityId>(query: DocumentNode, responseSelector: (queryResponse: ApolloQueryResult<ResponseObject>) => T[], convertId?: (id:Id) => number) {
  return async (ids: Id[], thunkApi: GetThunkAPI<AsyncEntityThunkConfig<T[]>>) => {
    const {getApolloClient} = thunkApi.extra;
    const state = thunkApi.getState();
    const domain = state.activeData.farm;
  
    if (!domain) {
      thunkApi.rejectWithValue([]);
    }
  
    try {
      const client = getApolloClient();
      const queryResponse = await client.query<ResponseObject>({ query, variables: { domain, ids: convertId ? ids.map(convertId) : ids}})
      return thunkApi.fulfillWithValue(responseSelector(queryResponse));
    } catch (error) {
      return thunkApi.rejectWithValue([]);
    }
  }
} 
